import { render, staticRenderFns } from "./cDocumentDashboardDocList.vue?vue&type=template&id=4890dab0&scoped=true"
import script from "./cDocumentDashboardDocList.vue?vue&type=script&lang=js"
export * from "./cDocumentDashboardDocList.vue?vue&type=script&lang=js"
import style0 from "./cDocumentDashboardDocList.vue?vue&type=style&index=0&id=4890dab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890dab0",
  null
  
)

export default component.exports